'use client'
import { FC, ReactNode, useEffect } from 'react'
type FashionECommerceLayoutProps = {
  children: ReactNode
}
const FashionECommerceLayout: FC<FashionECommerceLayoutProps> = ({ children }) => {
  useEffect(() => {
    document.body.setAttribute('data-theme', 'KMRS-Pink')

    return () => {
      document.body.removeAttribute('data-theme')
    }
  }, [])
  return children
}

export default FashionECommerceLayout
